import httpClient from '@/services/httpClient'
import { useMutation } from '@tanstack/react-query'

export const useConfirmSchedule = () => {
  const confirmScheduleMutation = useMutation({
    mutationFn: async (attendanceId: number | string) => {
      await httpClient.post(
        `/integration/app-paciente/confirmar-atendimento/${attendanceId}`,
      )
    },
  })

  return confirmScheduleMutation
}
